import httpClient from 'api/httpClient';
import { AuthBody, LoginRequest } from 'models/AuthBody';
import { DataRoomLoginSource } from 'models/DataRoomLoginSource';

// `source` tells the backend where the member entered the Data Room from, so it
// can stamp the `log_in` report row. `shareableLinkId` is only sent for the
// secure link source, so the link name can be resolved for that row.
function login(
  dataRoomId: string,
  userData?: LoginRequest,
  source?: DataRoomLoginSource,
  shareableLinkId?: string,
) {
  return httpClient.post<AuthBody>(`data-rooms/${dataRoomId}/auth/login`, {
    ...userData,
    source,
    ...(shareableLinkId && { shareableLinkId }),
  });
}

function preLogin(dataRoomId: string) {
  return httpClient.post<{
    shouldAuthenticate: boolean;
  }>(`data-rooms/${dataRoomId}/auth/pre-login`);
}

export default {
  login,
  preLogin,
};
